const utf8ToBase64 = (value) => window.btoa(unescape(encodeURIComponent(value)));
const base64ToUtf8 = (value) => decodeURIComponent(escape(window.atob(value)));

export const encodePlan = (plan) => {
  try {
    const json = JSON.stringify(plan);
    const token = utf8ToBase64(json).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    if (token.length > 1800) return null;
    return token;
  } catch (error) {
    return null;
  }
};

export const decodePlan = (token) => {
  if (!token) return null;
  try {
    const normalized = token.replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized + '==='.slice((normalized.length + 3) % 4);
    return JSON.parse(base64ToUtf8(padded));
  } catch (error) {
    return null;
  }
};
